import React, { useState } from 'react'
import { Routes, Route, Outlet, useNavigate } from 'react-router-dom'
//CSS
import styles from '../Routes.module.css'

import evaluateStyles from './LandingPages.module.css'
//Components
import TabbedView from '../../Components/Utils/TabbedView/TabbedView'
import { ITab } from '../../Types/ITab'
import EvaluateActive from './EvaluateActive'
import EvaluatePlanned from './EvaluatePlanned'
import EvaluateArchive from './EvaluateArchive'
import { setQuestionnaire } from '../../Redux/Store/Slices/questionnaire'
import { useAppDispatch, useAppSelector } from '../../Redux/Store/Store'
import { ImportQuestionnaireTemplate } from '../../API/TemplateBank/TemplateBank'
import Popup from '../../Components/Utils/Popup/Popup'
import ImportTemplate from '../../Components/Products/ImportTemplate/ImportTemplate'
import { getClient } from '../../Redux/Store/Slices/client'
import { ProductType } from '../../Types/ProductType'

const tabs: ITab[] = [
  {
    title: "Active",
    active: true,
    url: "/evaluate/active"
  },
  {
    title: "Archive",
    active: false,
    url: "/evaluate/archive"
  }
]

const Evaluate = () => {

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  
    const [showImportTemplate, setShowImportTemplate] = useState<boolean>(false);
    const [activeTab, setActiveTab] = useState<ITab>(tabs[0]);

    const client = useAppSelector(getClient);

    const handleImportTemplate = (templateId: string, observee?: string, departmentId?: string, partnerId?: string, groupIds?: string[]) => {
      const importTemplate = async () => {
        if(client){
          const questionnaire = await ImportQuestionnaireTemplate(templateId, client.id, departmentId, partnerId, groupIds);
          dispatch(setQuestionnaire(questionnaire));  
          // Navigate to the area route using the questionnaire ID as the areaId
          navigate(`/evaluate/${questionnaire.id}`);
        }
      }
      return importTemplate();
    }

  return (
    <div className={styles.container}>
      <div className={evaluateStyles.header}>
        <h3>Evaluate</h3>
        <TabbedView data={tabs} activeTab={activeTab} activeTabChanged={setActiveTab} />

      </div>
      
      <div className={styles.body}>
        {
          <Routes>
            <Route path="active" element={<EvaluateActive setShowImportTemplate={setShowImportTemplate} />} />
            <Route path="planned" element={<EvaluatePlanned />} />
            <Route path="archive" element={<EvaluateArchive setShowImportTemplate={setShowImportTemplate} />} />
          </Routes>
        }
      </div>

      <Popup  isVisible={showImportTemplate} onClose={() => setShowImportTemplate(!showImportTemplate)}>
          <ImportTemplate importHandler={handleImportTemplate} productType={ProductType.Evaluate} />
      </Popup>

      {/*



<Routes>
            <Route path="/moreevaluate" element={<Evaluate />}/>
          </Routes>


        <Card title="Provider T Level Plan V4" percentage={100} />
        <Card title="Ofsted Education Inspection Framework FES Long V5" percentage={34} />
        <Card title="Provider T Level Plan V2" percentage={82} />
        <Card title="DFE T Level Plan V4" percentage={61} />

*/}

    </div>
  )
}

export default Evaluate